export const defaultData = [{
    name: "GCH官网",
    room_type: "房型一",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "GCH官网",
    room_type: "房型二",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "携程",
    room_type: "房型一",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "携程",
    room_type: "房型二",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "美团",
    room_type: "房型一",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "美团",
    room_type: "房型二",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "温德姆中文",
    room_type: "房型一",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "温德姆中文",
    room_type: "房型二",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "温德姆英文",
    room_type: "房型一",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}, {
    name: "温德姆英文",
    room_type: "房型一",
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
}];



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/price/1.1/data.js